import { ListBox } from '$comp/navigation-bar-tool-box/components/list-box'
import { t } from '$i18n'
import { closeNavbarToolBox } from '$logic/router'
import { openNeviseCreator, openPostCreator } from '$logic/wapps/business'

export function WritingTools() {
  return (
    <ListBox
      title={t('navigationBarToolBox.writingsTools.title')}
      titleSx={{
        background: 'linear-gradient(60deg, #FA4545 13.4%, #F57073 86.6%)',
      }}
      items={[
        {
          title: t('wapps.nevise'),
          onClick: async () => {
            await closeNavbarToolBox()
            openNeviseCreator()
          },
        },
        {
          title: t('wapps.post'),
          onClick: async () => {
            await closeNavbarToolBox()
            openPostCreator()
          },
        },
      ]}
      borderColor="#F85253"
    />
  )
}
